import {createGlobalStyle } from 'styled-components';
import 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    // fonts: {
    //   main: string;
    // };
    // colors: {
    //   text: string;
    //   light: string;
    //   // add other color fields as needed
    // };
    // add other theme fields as needed
  }
}

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${({theme }) => theme.fonts.main};
    color: ${({theme }) => theme.colors.text};
    line-height: 1.5;
    background-color: ${({theme }) => theme.colors.light};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  input, textarea, select {
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
